<template>
    <v-app-bar
      app
      class="header"
      hide-on-scroll
      elevation="1"
      color="rgba(255,255,255,0.9)"
    >
      <!-- <v-app-bar-nav-icon></v-app-bar-nav-icon> -->

      <v-toolbar-title class="logo"><a href="/">Dog Salon Free</a></v-toolbar-title>

      <v-spacer></v-spacer>

      <v-menu
        left
        bottom
      >
        <template v-slot:activator="{ on }">
          <v-btn icon v-on="on">
            <v-icon>mdi-paw</v-icon>
          </v-btn>
        </template>

        <v-list>
          <v-list-item
            v-for="item in links"
            :key="item.id"
            @click="() => {}"
          >
            <v-list-item-title><a :href="item.url">{{ item.name }}</a></v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-app-bar>
</template>

<script>
export default {
  name: 'header',
  data() {
    return {
      links: [
        {id: 1,name: 'TOP', url: '/'},
        {id: 2,name: 'CONCEPT', url: '#concept'},
        {id: 3,name: 'SNS', url: '#sns'},
        {id: 4,name: 'MENU', url: '#menu'},
        {id: 5,name: 'ATTENTION', url: '#attention'},
        {id: 6,name: 'OWNER', url: '#owner'},
        {id: 7,name: 'CONTACT', url: '#contact'}
      ]
    }
  }
}
</script>

<style lang="scss" scoped>
  .header {
    // z-index: 100;
    // display: flex;
    // position: fixed;
    // justify-content: space-between;
    // width: 100%;
    // background: $header-color;
    // background: transparent;
    // padding:5px 0;
    height: $header-height;
  }
  .logo {
    display: block;
    margin-right: auto;
    padding:3px;
    font-family: $site-title-font;
    font-size: 25px;
    margin: 0 10px 0 5px;
    transition: 0.3s;
    &:hover {
      letter-spacing: 1px;
      transition: 0.3s;
    }
  }
  // v-app-bar {
  //   display: flex;
  //   justify-content: space-between;
  // }
  // v-toolbar-title {
  //   margin-right: auto;
  //   margin-left: 0;
  // }
  // v-menu {
  //   margin-right: 0;
  //   margin-left: auto;
  // }
      // .nav {
      //   display: block;
      //   margin-left: auto;
      //   ul {
      //     display: flex;
      //     justify-content: center;
      //     .btn {
      //       text-align: center;
      //       vertical-align: middle;
      //       display: inline-block;
      //       min-width: 65px;
      //       height: 35px;
      //       cursor: pointer;
      //       letter-spacing: 2px;
      //       position:relative;
      //       overflow:hidden;
      //       margin: 0 5px;
      //       border-bottom: 1px solid $dark-font-color;
      //       transition: 0.3s;
      //       a {
      //         font-size: 0.6rem;
      //         display: block;
      //         width: 100%;
      //         height: 100%;
      //         letter-spacing: 0.3rem;
      //         line-height: 2.4rem;
      //         transition: 0.3s;
      //       }
      //       &:hover {
      //         background: $sub-color;
      //         border-radius: 5px;
      //         transition: 0.3s;
      //         a {
      //         letter-spacing: 0.2rem;
      //         transition: 0.3s;
      //         }
      //       }
      //     }
      //   }
      // }
</style>
